export default __webpack_public_path__ + "static/media/projections_equations1.fe0c3455.png";